import { useEffect, useState, useCallback } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api, apiError } from "@/lib/api";

const FLOW = ["new", "preparing", "ready", "completed", "cancelled"];
const CLS = {
  new: "text-amber-400 border-amber-500/30 bg-amber-500/10",
  preparing: "text-cyan-400 border-cyan-500/30 bg-cyan-500/10",
  ready: "text-emerald-400 border-emerald-500/30 bg-emerald-500/10",
  completed: "text-slate-300 border-slate-500/30 bg-slate-500/10",
  cancelled: "text-red-400 border-red-500/30 bg-red-500/10",
};

export default function OrdersTab() {
  const [items, setItems] = useState(null);
  const [filter, setFilter] = useState("");
  const load = useCallback(() => { api.get("/admin/orders", { params: filter ? { status: filter } : {} }).then((r) => setItems(r.data)); }, [filter]);
  useEffect(() => { load(); const t = setInterval(load, 15000); return () => clearInterval(t); }, [load]);

  const setStatus = async (id, status) => { try { await api.patch(`/admin/orders/${id}/status`, { status }); load(); } catch (e) { toast.error(apiError(e)); } };

  return (
    <div>
      <div className="flex gap-2 mb-4 flex-wrap">
        {[["", "All"], ...FLOW.map((s) => [s, s])].map(([id, l]) => (
          <button key={id} data-testid={`order-filter-${id || "all"}`} onClick={() => setFilter(id)} className={`px-4 h-10 rounded-xl text-sm border capitalize ${filter === id ? "bg-purple-600 border-purple-400" : "glass border-purple-500/30 text-slate-300"}`}>{l}</button>
        ))}
      </div>
      {!items ? <Loader2 className="animate-spin text-purple-400" /> : items.length === 0 ? <p className="text-slate-500 text-center py-10">No orders.</p> : (
        <div className="grid sm:grid-cols-2 gap-3">
          {items.map((o) => (
            <div key={o.id} className="glass rounded-2xl p-4" data-testid={`order-${o.order_id}`}>
              <div className="flex justify-between items-center mb-2">
                <span className="font-mono text-purple-300 text-sm">{o.order_id}</span>
                <span className={`text-[10px] px-2 py-0.5 rounded-full border uppercase ${CLS[o.status] || CLS.new}`}>{o.status}</span>
              </div>
              <p className="text-sm font-semibold">{o.station_name} · {o.customer_name}</p>
              <div className="text-sm text-slate-400 mt-1">{(o.items || []).map((i, x) => <div key={x}>{i.name} × {i.qty}{i.notes ? ` (${i.notes})` : ""}</div>)}</div>
              {o.notes && <p className="text-xs text-amber-300 mt-1">Note: {o.notes}</p>}
              <p className="font-display font-bold text-emerald-400 mt-2">₹{o.total}</p>
              <div className="flex flex-wrap gap-2 mt-3 pt-3 border-t border-purple-500/10">
                {FLOW.filter((s) => s !== o.status).map((s) => (
                  <Button key={s} size="sm" variant="outline" onClick={() => setStatus(o.id, s)} data-testid={`set-${s}-${o.order_id}`} className="h-8 border-purple-500/30 bg-transparent capitalize text-xs">{s}</Button>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
